import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {ActionList} from '@primer/react'
import {Box} from '@primer/styled-react'
import type {FC} from 'react'

import styles from './RowLoading.module.css'

type Props = {
  width?: string
  showCompactDensity?: boolean
}

const RowLoading: FC<Props> = ({width = 'random', showCompactDensity = false}) => (
  <ActionList.Item aria-disabled="true">
    <Box
      sx={{
        alignItems: showCompactDensity ? 'center' : 'flex-start',
        height: showCompactDensity ? '20px' : '40px',
      }}
      className={styles.rowLoadingContainer}
    >
      <LoadingSkeleton variant="elliptical" height="md" width="md" />
      <div className={styles.rowLoadingContent}>
        <LoadingSkeleton variant="rounded" height="sm" width={width}>
          <span className="sr-only">loading</span>
        </LoadingSkeleton>
        {!showCompactDensity && (
          <LoadingSkeleton variant="rounded" height="12px" width={width} className={styles.LoadingSkeleton} />
        )}
      </div>
    </Box>
  </ActionList.Item>
)

export default RowLoading
